var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_7432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3734 8.76978C13.3232 9.38162 13.9888 10.2106 13.9888 11.3158V13.2895H16.7619V11.3158C16.7619 9.88162 14.2869 9.03293 12.3734 8.76978Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2157 8.02634C12.7478 8.02634 13.9888 6.84871 13.9888 5.39476C13.9888 3.94082 12.7478 2.76318 11.2157 2.76318C10.8898 2.76318 10.5848 2.82897 10.2936 2.92108C10.869 3.59871 11.2157 4.46055 11.2157 5.39476C11.2157 6.32897 10.869 7.19082 10.2936 7.86845C10.5848 7.96055 10.8898 8.02634 11.2157 8.02634Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05587 8.02634C8.58804 8.02634 9.82902 6.84871 9.82902 5.39476C9.82902 3.94082 8.58804 2.76318 7.05587 2.76318C5.5237 2.76318 4.28271 3.94082 4.28271 5.39476C4.28271 6.84871 5.5237 8.02634 7.05587 8.02634ZM7.05587 4.07897C7.81849 4.07897 8.44245 4.67108 8.44245 5.39476C8.44245 6.11845 7.81849 6.71055 7.05587 6.71055C6.29325 6.71055 5.66929 6.11845 5.66929 5.39476C5.66929 4.67108 6.29325 4.07897 7.05587 4.07897Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05589 8.68433C5.20481 8.68433 1.50958 9.5659 1.50958 11.3159V13.2896H12.6022V11.3159C12.6022 9.5659 8.90697 8.68433 7.05589 8.68433ZM11.2156 11.9738H2.89616V11.3225C3.03482 10.8488 5.18401 10.0001 7.05589 10.0001C8.92777 10.0001 11.077 10.8488 11.2156 11.3159V11.9738Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_7432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6389,
    height: 15.7895,
    fill: "#323232",
    transform: "translate(0.816284 0.131592)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.468385f3b73bbb802b4c8d8fd9f7c756.svg";
export { ForwardRef as ReactComponent };